export default {
  companySurveysAnalyticsMetadata: {
    titleTabs: {
      statistic: 'Статистика',
      wellbeing: 'Благополучие',
      burnout: 'Выгорание',
    },

    cycleTitle: 'Фактические циклы исследования с датами',
    proportionTitle: 'Доля сотрудников, прошедших опрос по командам',
    employeeTitle: 'Всего сотрудников',
    joinedTitle: 'Подключены к опросам',
    percentTitle: 'Доля сотрудников, прошедших опросы',
    dynamicTitle: 'Динамика ответов по опросам',
    all: 'Всего',

    cycleHeaders: {
      cycle: 'Цикл',
      startDate: 'Дата старта',
    },
    proportionHeaders: {
      div1: 'Подразделение 1',
      div2: 'Подразделение 2',
      team: 'Команда',
      connected: 'Подключено',
      proportion: 'Доля',
    },

    commonBurnoutTitle: 'Блок «Общее выгорание»',
    commonBurnoutSubTitle:
      'Показатель рассчитан по сотрудникам, ответившим более, чем на 80% вопросов. Количество таких сотрудников указано в центре диаграммы.',
    commonBurnoutDesc: `<p><em>Общий показатель выгорания</em></p>
          <p>
            Представляет собой состояние эмоционального, психологического и физического истощения,
            которое часто развивается в результате длительного переживания хронического стресса на
            рабочем месте. Это явление может затронуть людей в различных профессиональных сферах и
            уровнях должностей. Оно проявляется в форме трех ключевых компонентов:
          </p>
          <ol>
            <li>
              <strong>Эмоциональное выгорание</strong> характеризуется чрезмерной усталостью,
              отсутствием энергии и ощущением эмоционального истощения.
            </li>
            <li>
              <strong>Деперсонализация (или Апатия)</strong> выражается в отстраненном, циничном
              отношении к окружающим, клиентам или коллегам.
            </li>
            <li>
              <strong>Профессиональная эффективность</strong> уменьшается, что приводит к потере
              удовлетворения от достижений в профессиональной деятельности.
            </li>
          </ol>
          <p>
            В результате <strong>выгорания</strong> люди могут потерять мотивацию, испытывать
            беспокойство и, в конечном итоге, сталкиваться с серьезными последствиями для своего
            физического и психического здоровья.
          </p>
          <p>
            Раннее распознавание и эффективные стратегии борьбы с выгоранием важны для поддержания
            здоровья и профессионального благополучия сотрудников.
          </p>`,
    commonBurnout: 'Общее выгорание',
    commonBurnoutDynamic: 'Общее выгорание в динамике',
    commonBurnoutEmployee: 'Количество сотрудников по уровню выгорания в командах',
    commonBurnoutTitleTabs: {
      common: 'Выгорание',
      stages: 'Стадии выгорания сотрудников',
    },

    emotionalBurnoutTitle: 'Блок «Эмоциональное выгорание»',
    emotionalBurnoutSubTitle:
      'Показатель рассчитан по сотрудникам, ответившим более, чем на 80% вопросов. Количество таких сотрудников указано в центре диаграммы.',
    emotionalBurnoutDesc: `<p><em>Эмоциональное выгорание (истощение)</em></p>
          <p>
            Эмоциональное выгорание это один из ключевых компонентов синдрома профессионального
            выгорания, который характеризуется чувством эмоционального и физического истощения,
            обусловленного чрезмерной или длительной нагрузкой на работе. Эмоциональное истощение
            может возникнуть, когда сотрудник переживает чрезмерный стресс и давление, не получает
            поддержки или не имеет возможности эффективно справляться с эмоциональными
            переживаниями. Этот аспект выгорания фокусируется на эмоциональных ресурсах, которые
            сотрудник тратит в ходе выполнения профессиональных обязанностей.
          </p>

          <p>Основные черты эмоционального выгорания включают:</p>

          <ul class="pl-0">
            <li>
              <strong>Усталость и истощение:</strong> сотрудник испытывает постоянную усталость,
              психическое и физическое истощение даже после небольших нагрузок.
            </li>
            <li>
              <strong>Потеря энергии и эмоциональные спады:</strong> чувство потери энергии и
              изнеможения даже в начале рабочего дня, потеря интереса к работе и чувство равнодушия
              к профессиональным задачам.
            </li>
            <li>
              <strong>Чувство беспомощности:</strong> сотрудник может чувствовать беспомощность и
              неспособность справляться с повседневными, порой даже самыми простыми, задачами.
            </li>
            <li>
              <strong>Эмоциональная отстраненность:</strong> отстраненность и чувство эмоционального
              отдаления от окружающих, включая коллег и клиентов.
            </li>
            <li>
              <strong>Раздражительность:</strong> постоянное чувство раздражения, снижение уровня
              терпимости в ответ на мелкие или повседневные проблемы.
            </li>
            <li>
              <strong>Эмоциональная пустота:</strong> ощущение эмоциональной пустоты и отсутствия
              энтузиазма.
            </li>
            <li>
              <strong>Затрудненное преодоление стресса:</strong> быстрое истощение эмоциональных
              ресурсов в стрессовых ситуациях, сильные и долгие переживания.
            </li>
          </ul>`,
    emotionalBurnout: 'Эмоциональное выгорание',
    emotionalBurnoutDynamic: 'Эмоциональное выгорание в динамике',
    emotionalBurnoutFactors: 'Эмоциональное выгорание по факторам',

    employeeWell: {
      titleTabs: {
        statistic: 'Статистика',
        participation: 'Вовлеченность и удовлетворенность',
        enps: 'eNPS',
        emotion: 'Эмоциональное состояние',
      },
    },

    depersonalizationBurnoutTitle: 'Блок «Деперсонализация»',
    depersonalizationBurnoutSubTitle:
      'Показатель рассчитан по сотрудникам, ответившим более, чем на 80% вопросов. Количество таких сотрудников указано в центре диаграммы.',
    depersonalizationBurnoutDesc: `
        <p>
          Деперсонализация означает отношение сотрудника к своей работе, клиентам, коллегам и
          профессиональным обязанностям с циничным, равнодушным и отчужденным образом. Этот
          компонент выгорания. Деперсонализация является серьезным фактором, влияющим на качество
          работы, эффективность команды и общую удовлетворенность сотрудника.
        </p>

        <p>Основные черты деперсонализации в рамках выгорания включают:</p>

        <ol class="pl-0">
          <li>
            <strong>Циничное отношение:</strong> сотрудник может проявлять циничность и скептицизм
            по отношению к клиентам, коллегам и работе. Он может проявлять равнодушие к их
            потребностям, проблемам, вопросам и запросам.
          </li>
          <li>
            <strong>Отчужденность:</strong> отчужденность проявляется в том, что сотрудник чувствует
            эмоциональное отдаление от окружающих. Это выражается в отсутствии интереса к их
            чувствам, переживаниям и в равнодушии к тому, что происходит вокруг.
          </li>
          <li>
            <strong>Негативные стереотипы:</strong> сотрудник с деперсонализацией может развивать
            негативные стереотипы о клиентах, коллегах и профессиональных задачах. Это может
            привести к формированию предвзятых мнений и негативных оценок.
          </li>
          <li>
            <strong>Снижение Эмпатии, сарказм и ирония:</strong> в попытке справиться с негативными
            эмоциями и отчуждением, сотрудник может использовать сарказм и иронию в общении с
            клиентами и коллегами, что усугубляет проблемы взаимодействия.
          </li>
          <li>
            <strong>Отсутствие Желания Помогать:</strong> сотрудники могут терять желание помогать
            другим, появляется отсутствие инициативы в решении проблем, нежелание выходить за рамки
            минимальных обязанностей.
          </li>
        </ol>`,
    depersonalizationBurnout: 'Деперсонализация',
    depersonalizationBurnoutDynamic: 'Деперсонализация в динамике',
    depersonalizationBurnoutFactors: 'Деперсонализация по факторам',

    professionalEfficiencyTitle: 'Блок «Профессиональная эффективность»',
    professionalEfficiencySubTitle:
      'Показатель рассчитан по сотрудникам, ответившим более, чем на 80% вопросов. Количество таких сотрудников указано в центре диаграммы.',
    professionalEfficiencyDesc: `
          <p>
            Этот компонент отражает ощущение утраты личной значимости, профессиональной
            эффективности и снижения удовлетворенности от своей работы.
          </p>

          <p><strong>Основные признаки снижения личной реализации включают:</strong></p>

          <ul class="pl-0">
            <li>
              <strong>Снижение удовлетворенности работой:</strong> сотрудник чувствует, что его
              профессиональные результаты и усилия перестают приносить ему удовлетворение.
            </li>
            <li>
              <strong>Потеря интереса:</strong> снижение интереса к профессиональным задачам и
              утрата внутренней мотивации.
            </li>
            <li>
              <strong>Сомнение в собственных способностях:</strong> появление сомнений в своей
              компетентности и способности достичь успеха в работе.
            </li>
            <li>
              <strong>Чувство бесполезности:</strong> чувство бесполезности и неэффективности в
              рамках профессиональной деятельности.
            </li>
            <li>
              <strong>Отсутствие достижений:</strong> ощущение, что профессиональные усилия не
              приносят заметных результатов или достижений.
            </li>
            <li>
              <strong>Утрата смысла:</strong> потеря смысла и цели в профессиональной деятельности,
              чувство монотонности и рутины.
            </li>
            <li>
              <strong>Избегание ответственности:</strong> тенденция избегать или откладывать
              выполнение профессиональных обязанностей, поиск возможности переложить ответсвенность
              на других.
            </li>
          </ul>`,
    professionalEfficiency: 'Профессиональная эффективность',
    professionalEfficiencyDynamic: 'Профессиональная эффективность в динамике',
    professionalEfficiencyFactors: 'Профессиональная эффективность по факторам',

    burnoutSubTitle:
      'График отображает изменение компонентов выгорания между циклами опросов на основе баллов, набранных сотрудниками. Позволяет отслеживать динамику изменения выгорания даже в случае, если стадия выгорания не изменилась.',
    burnoutDynamic: 'Динамика по выгораниям',
    enpsDesc: {
      support: `
           <em>Сторонники</em> - те респонденты, которые поставили высшие баллы 8, 9 или 10. Эти
          люди с большой долей вероятности являются важнейшим ключом для анализа результатов и
          улучшения ситуации. Важно понять, что именно этой группе опрошенных нравится в компании,
          что заставило их поставить столь высокую оценку. Используйте полученную информацию, для
          найма и удержания лучших талантов.
        `,
      loyal: `
           <em>Лояльные</em> - участники опроса, которые поставили оценку 7 баллов, они в целом
          довольны условиями в компании, выполняют свою работу «формально» качественно, но без
          стремления сделать результат как можно лучше. Готовы рекомендовать компанию, но при этом
          могут сменить место работы, если появится предложение поинтереснее.
        `,
      skeptic: `
           <em>Скептики</em> - респондент считается скептиком, когда выбирает 5 или 6 баллов. Это
          сотрудники, которые видят проблемы и не очень довольны условиями работы в компании. Очень
          важно прислушаться к ним и узнать причины дискомфорта, чтобы попытаться изменить ситуацию
          и, тем самым, увеличить лояльность.
        `,
      critic: `
           <em>Критики</em> - оценка респондентов 0 - 4 баллов. Эти сотрудники недовольны
          условиями работы в компании. Как правило, они открыто критикуют процессы, культуру.
          Недовольство может сказываться на качестве работы — сотрудники выполняют свои обязанности
          формально. Они не хотят ничего менять и не поддержат изменения. С этой категорией
          персонала важно установить контакт: узнать причину разочарования и постараться улучшить
          ситуацию. Критики являются важным активом компании — они имеют смелость указывать на
          реальные проблемы.
        `,
    },
    eNPS: 'eNPS',
    emotion: {
      title: 'Эмоциональное состояние сотрудников',
      desc: 'Учитывались ответы на вопрос: «Опиши свое эмоциональное состояние сейчас» по шкале от 0 до 5',
      anxietyLevel: 'Уровень тревожности',
      averageTitle: 'Средний показатель настроения компании',
    },
    participation: {
      participationTitle: 'Блок «Вовлеченность и удовлетворенность»',
      participationDesc:
        'Блок показывает данные по показателям общей вовлеченности и удовлетворенности, а также долю положительных ответов по 11 факторам удовлетворенности. Факторы удовлетворенности указаны в порядке их значимости.',
      involvementDynamic: 'Вовлеченность в динамике',
      contentmentDynamic: 'Удовлетворенность в динамике',
      summaryFactors: 'Сводная по факторам',
      summaryFactorsTable:
        'Таблица показывает долю положительных ответов (только ответы, содержащие оценку)',
      summary: 'Сводная по компании',
      summaryTeam: 'Сводная по командам',
      involvement: 'Вовлеченность',
      involvementDesc:
        'показатель отражает мотивацию сотрудников и продуктивность рабочей среды в компании / подразделении.',
      involvementFactors: 'Факторы вовлеченности сотрудников',
      recommendationsTitle: 'Рекомендации по повышению вовлеченности:',
      recommendationsDesc: {
        firstStep: `<p><em>1. Анализ результатов по подразделению</em></p>`,
        firstStepDesc: `На этом шаге руководитель может выявить проблемные зоны в подразделении относительно
        оценок по компании в целом и определить приоритеты для работы (рекомендуется брать не более
        трех проблемных зон на ближайший квартал)`,
        secondStep: `<p><em>2. Понять, как сам руководитель может повлиять на вовлеченность команды.</em></p>`,
        secondStepDesc: `Результаты опроса сотрудников – это обратная связь для компании и для руководителя.
        Опираясь на эти данные, руководитель может скорректировать свои методы управления.
        Руководитель оказывает серьезное влияние на вовлеченность в своем подразделении, поэтому ему
        нужно поддерживать свой уровень вовлеченности на высоком уровне и демонстрировать это
        команде, «заражая» ее своим энтузиазмом. Кроме того, руководитель во многом доносит команде
        видение стратегии компании и информацию от других подразделений, поэтому нужно заботиться о
        том, чтобы информации было достаточно и она подавалась в правильном ключе.`,
        thirdStep: `<p><em>3.Спросить команду о том, как улучшить рабочую атмосферу.</em></p>`,
        thirdStepDesc: `Сотрудники заполняют опрос в расчете, что их мнение будет услышано и компания готова
        работать над тем, чтобы улучшать опыт сотрудников (от англ. employee experience). В конечном
        счете положительный опыт сотрудников влияет на то, что лучшие специалисты приходят работать
        в компанию и остаются в ней надолго. Руководителю следует донести результаты опроса до
        сотрудников своего подразделения, обратив их внимание как на положительные, так и на
        отрицательные моменты.`,
        time: `<p>
        <em
          >Нужно выделить отдельное время на обсуждение – от 1 до 2 часов, а также лучше заранее
          выделить приоритетные факторы для работы. Полезно задать команде открытые вопросы:</em
        >
      </p>`,
        firstQuestion: `Как вы думаете, какие наиболее проблемные моменты показал опрос?`,
        secondQuestion: `Что именно вам не нравится в том или ином аспекте работы (назвать факторы, пояснить их
        значение, какие вопросы входят)?`,
        thirdQuestion: `На чем мы как команда готовы сосредоточиться в ближайший месяц/2 месяца/квартал?`,
      },
      contentment: 'Удовлетворенность',
      contentmentDesc:
        'выявление причин фрустрации и стресса, оценка по 11 факторам. Это то, как чувствуют себя сотрудники, переступая порог офиса или то, как они оценивают очередной год, проведенный с компанией.',

      successConditions: 'Условия для успеха',
      successConditionsDesc:
        'Формирует для сотрудника компания – это достаточное количество ресурсов и инструментов для успешного выполнения его рабочих обязанностей, а также свободный доступ к необходимой информации и отлаженный процесс принятия решений.',
      developmentOpportunities: 'Возможности для развития',
      developmentOpportunitiesDesc:
        '«Возможности для развития» отражают отношение сотрудника к тому, какие возможности для карьерного или профессионального развития предоставляет ему компания – видит ли он возможности роста, есть ли доступ к обучению и пр.',

      rewardRecognition: 'Вознаграждение и признание',
      rewardRecognitionDesc:
        'Фактор «Вознаграждение и признание» отражает понимание сотрудником того, что его труд ценят и справедливо оплачивают.',

      lead: 'Руководитель',
      leadDesc:
        'Фактор «Руководитель» характеризуется степенью лояльности к своему руководителю и удовлетворенностью работой с ним, которая зависит от его управленческих навыков: умения ставить цели, давать обратную связь, заботиться о карьерном росте сотрудников и своевременно транслировать информацию от руководства компании.',

      team: 'Команда',
      teamDesc:
        'Фактор «Команда» отражает отношение сотрудника к атмосфере в его команде, а также к степени ее организованности – к тому, насколько слажена работа в коллективе и как происходит распределение ответственности.',

      authority: 'Полномочия',
      authorityDesc:
        '«Полномочия» – это восприятие сотрудником той степени свободы, которую ему предоставляет компания в работе, возможности принимать самостоятельные решения, планировать свою работу, выполнять задачи.',

      consist: 'Согласованность',
      consistDesc:
        'Согласованность определяется тем, насколько, по мнению сотрудника, ему подходит его функциональная роль и компания – он понимает, что от него требуется на текущей должности, ему нравятся его задачи и он верит в успех компании, в которой работает.',

      clientFocus: 'Фокус на клиента',
      clientFocusDesc:
        'Фактор «Фокус на клиента» показывает отношение сотрудника к продукту, который выпускает компания: довольны ли, по его мнению, клиенты компании, готов ли он сам порекомендовать продукт своим знакомым.',

      respect: 'Уважение к сотрудникам',
      respectDesc:
        'Оценка фактора «Уважение к личности» основывается на том, насколько справедливо в компании относятся к каждому человеку и насколько каждый может свободно выражать свои идеи и мнения.',

      innovation: 'Инновации',
      innovationDesc:
        'Фактор «Инновации» отражает восприятие сотрудниками культуры инноваций в компании: могут ли они реализовывать новые идеи, используются ли в работе инновационные решения.',

      collaboration: 'Кросс-функциональное взаимодействие',
      collaborationDesc:
        '«Кросс-функциональное взаимодействие» или сотрудничество – это отношение к качеству взаимодействия сотрудников между разными подразделениями компании.',
      recommendationsFinalTitle:
        'Рекомендации по дальнейшим действиям для повышения уровня удовлетворенности:',
      recommendationsFinalDesc: {
        first:
          'По итогам опроса мы рекомендуем провести фокус-группы с наиболее проблемными командами и подразделениями — чтобы уточнить, чем вызваны низкие результаты, вскрыть конкретные «проблемные» факторы и возможности улучшения ситуации, по мнению самих сотрудников.',
        second:
          'Затем на сессии с менеджментом разработайте дорожную карту изменений: определите действия по ключевым проблемам и горячим точкам, проработайте инструменты поддержания наиболее сильных факторов удовлетворенности. На выходе — реалистичный план для повышения уровня удовлетворенности, опирающийся на данные и статистику.',
      },
      summaryTableTitle: 'Наименование',
      summaryTableValue: 'Значение',
    },
    answersTableHeaders: {
      question: 'Вопрос',
      supporters: 'Положительные',
      loyal: 'Лояльные',
      skeptics: 'Скептические',
      neutral: 'Скептические',
      critics: 'Отрицательные',
    },
    burnoutTableHeaders: {
      team: 'Команда',
      question: 'Вопрос',
      never: 'Никогда',
      very_rare: 'Очень редко',
      rarely: 'Редко',
      sometimes: 'Иногда',
      often: 'Часто',
      very_often: 'Очень часто',
      almost_always: 'Почти всегда',
    },
    chartsData: {
      positive_answer: 'Положительные',
      loyal_answer: 'Лояльные',
      skeptic_answer: 'Скептические',
      negative_answer: 'Отрицательные',
      neutral_answer: 'Нейтральные',

      extremely_low_expression: 'Очень низкое',
      low_expression: 'Низкое',
      medium_expression: 'Среднее',
      high_expression: 'Высокое',
      extremely_high_expression: 'Очень высокое',
      insufficient_data: 'Недостаточно данных',

      extremely_high_prof_efficiency: 'Очень высокая',
      high_prof_efficiency: 'Высокая',
      medium_prof_efficiency: 'Средняя',
      low_prof_efficiency: 'Низкая',

      loyal: 'Лояльные',
      skeptics: 'Скептики',
      supporters: 'Сторонники',
      critics: 'Критики',
    },
    burnoutStages: {
      burnoutDepersonalizationTableTitle: 'Деперсонализация динамика по людям',
      burnoutEfficiencyTableTitle: 'Профессиональная эффективность динамика по людям',
      burnoutEmotionTableTitle: 'Эмоциональное выгорание динамика по людям',
      burnoutGeneralTableTitle: 'Общее выгорание динамика по людям',
      burnoutStagesTableTitle: 'Стадии выгорания сотрудников',
      burnoutStagesTitle: `<p>
            Таблица содержит информацию о каждом сотруднике и их текущем уровне выгорания, включая
            компоненты выгорания.
          </p>
          <ul>
            <li>
              <strong>Достоверность:</strong> Расчет по количеству ответов сотрудника, связанных с определенным компонентом. Уровень выгорания рассчитывается, если достоверность не менее 80%.
            </li>
            <li>
              <strong>Сумма баллов:</strong> Числовое значение итоговых результатов сотрудника, позволяющее провести условное ранжирование. Чем больше баллов, тем сильнее выражено выгорание. Максимальное значение - 126.
            </li>
          </ul>
          <p>
            Для фильтрации по подразделениям и сотрудникам нажмите на нужное значение в таблице ниже.
          </p>`,
      burnoutStagesSubTitle: `<p>
            Таблицы ниже отражают изменение выраженности выгорания и его компонентов у сотрудников.
          </p>
      `,
      EmployeeTableHeader: {
        div1: 'Подразделение 1',
        div2: 'Подразделение 2',
        team: 'Команда',
        last_name: 'Фамилия',
        first_name: 'Имя',
        email: 'email',
        emotional_burnout: 'Эмоционал. выгорание',
        emotional_burnout_reliability: 'ЭВ Достоверность',
        professional_efficiency_reliability: 'ПЭ Достоверность',
        professional_efficiency: 'Проф. эффективность',
        depersonalization: 'Деперсонализация',
        depersonalization_reliability: 'Д Достоверность',
        common_burnout: 'Общее',
        sum_score: 'Сводка',
        employee: 'Сотрудник',
      },
    },

    filters: {
      cycle: 'Цикл',
      team: 'Команда',
      div1: 'Подразделение',
      div2: 'Подразделение 2',
      lastname: 'Фамилия',
    },
    summary: 'Всего',
    summaryCompanyAndTeam: {
      authority: 'Полномочия',
      consistency: 'Согласованность',
      contentment: 'Удовлетворенность',
      cross_f_interaction: 'Кросс-функц. взаим-вие',
      customer_focus: 'Фокус на клиента',
      development_opportunities: 'Возможности для развития',
      innovation: 'Инновации',
      involvement: 'Вовлеченность',
      lead: 'Руководитель',
      respect_for_staff: 'Уважение к личности',
      reward_recognition: 'Вознаграждение и признание',
      success_conditions: 'Условия для успеха',
      teams: 'Команды',
      div1: 'Подразделение 1',
      div2: 'Подразделение 2',
      sub_div: 'Подотдел',
    },
    noData: 'Нет данных',
    answers: 'Ответы',
    cycle: 'Цикл',
    count: 'Количество',
    veryDisturbing: 'Очень тревожное',
    excellent: 'Отличное',
    subdivision: 'Подразделение',
    middleCount: 'Средний',
    donatChartLegend: `
      <p><b>Положительные</b> - доля ответов, содержащих 8, 9 или 10 баллов</p>
      <p><b>Лояльные</b> - оценка от сотрудников 7 баллов</p>
      <p><b>Скептические</b> - оценка 5 и 6 баллов</p>
      <p><b>Отрицательные</b> - доля ответов с оценкой 0 - 4 баллов</p>`,
    from: 'из',
    hideAll: 'Свернуть все',
    showAll: 'Развернуть все',
    placeholders: {
      team: 'Поиск по подразделению',
      lastname: 'Поиск по фамилии',
    },
    linesPerPage: 'Строк на странице',

    departments: 'Подразделения',
    exportFrom: 'от',
    allCompany: 'Вся компания',
    activeFilters: 'Применённые фильтры',
    researchAnalytic: 'Аналитика по исследованию',
  },
};
